import { render, staticRenderFns } from "./footerDescription.vue?vue&type=template&id=a0e5c670&scoped=true&"
import script from "./footerDescription.vue?vue&type=script&lang=js&"
export * from "./footerDescription.vue?vue&type=script&lang=js&"
import style0 from "./footerDescription.vue?vue&type=style&index=0&id=a0e5c670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e5c670",
  null
  
)

export default component.exports